import React from "react";
import { PetDetailsScreen } from "~/features/my-pets/PetDetailsScreen";

const Component = () => {
  return <PetDetailsScreen />;
};

export default Component;
